module.exports = __webpack_public_path__ + "media/sirine.b721e395.mp3";